<script>
import Layout from '@layouts/main'
import LayoutContent from '@layouts/content'
import PageTitle from '@components/page-title'

export default {
  components: { Layout, LayoutContent, PageTitle },
  props: {
    message: {
      type: String,
      default: `Thank you for registering for access to OHLink. Your email has been verified.
        Please email ohlink@chninc.net to authorize your account.
        (You must be an authorized employee of a core provider or service provider to register for site access).`,
    },
  },
}
</script>

<template>
  <Layout>
    <PageTitle title="Register" />
    <LayoutContent>
      <h4 :class="$style.message">{{ message }}<br /></h4>
    </LayoutContent>
  </Layout>
</template>

<style lang="scss" module>
@use '@design' as *;

.message {
  color: #fff;
}
</style>
